import { LocaleFile } from "./localeFile";
import { Utilities } from "./utilities";

export class LocaleBuilder {
  _locales: any;

  constructor() {
    this._locales = {};
  }

  addLocaleString(locale: string, key: string, value: string): void {
    this.getLocaleFile(locale).addResource(key, value);
  }

  getLocaleFileResources(locale: string): object {
    locale = LocaleBuilder.fixLocaleCasing(locale);
    Utilities.assert(
      !Utilities.isNullOrUndefined(this._locales[locale]),
      "requested locale should exist in the manifest: " + locale,
    );
    return this.getLocaleFile(locale).getResources();
  }

  getLocales(): Array<string> {
    return Object.keys(this._locales);
  }

  private getLocaleFile(locale: string): LocaleFile {
    // Locales are case insensisive so we make sure that we store them that way
    locale = LocaleBuilder.fixLocaleCasing(locale);
    let localeFile: LocaleFile = this._locales[locale];

    if (Utilities.isNullOrUndefined(localeFile)) {
      localeFile = this._locales[locale] = new LocaleFile();
    }

    return localeFile;
  }

  static fixLocaleCasing(locale: string): string {
    if (!Utilities.isNullOrUndefined(locale)) {
      return locale.toLowerCase();
    }

    return locale;
  }
}
